import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { Quasar, Notify, Dialog } from 'quasar';
import { VueQueryPlugin } from '@tanstack/vue-query';

import '@quasar/extras/material-icons/material-icons.css';
import 'quasar/src/css/index.sass';
import './app/styles.scss';

import App from './app/App.vue';
import { useSessionStore } from './entities/session/session.store.js';
import { router } from './app/router.js';
import { i18n } from './app/i18n.js';
import { vueQueryOptions } from './app/query.js';

const app = createApp(App);

// Pinia first: the router guard reads the session store on the very first
// navigation, which happens during `router.isReady()` below.
app.use(createPinia());
app.use(Quasar, { plugins: { Notify, Dialog } });
app.use(i18n);
app.use(VueQueryPlugin, vueQueryOptions);
app.use(router);

// Started here so the first paint is not delayed by a round trip the guard
// would make anyway. The guard awaits the same promise, which is what
// actually guarantees it: the router starts navigating when it is installed,
// above, and does not wait for this line to be reached.
void useSessionStore()
  .whenRestored()
  .then(() => router.isReady())
  .then(() => app.mount('#app'));
